import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css'; 
import './Editor.css'; // Make sure the CSS provided below is in this file

const RichTextEditor = ({ value, onChange, placeholder, id }) => {
  
  const modules = {
    toolbar: [
      [{ font: [] }], // Quill handles fonts better via classes
      [{ size: ['small', false, 'large', 'huge'] }], 
      ['bold', 'italic', 'underline'],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['clean'],
    ],
  };

  const formats = [
    'font', 'size', 'bold', 'italic', 'underline', 
    'color', 'background', 'align', 'clean'
  ];

  // React Quill onChange provides (content, delta, source, editor)
  // We only need 'content' (the HTML string)
  const handleChange = (content) => {
    onChange(content);
  };

  return (
    <div className="rich-text-editor-wrapper" id={id}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};

export default RichTextEditor;